enum HomePageExperience {
    FirstTimeVisitor = 0,
    ReturnVisitor = 1,
    Transfer = 2,
}

export default HomePageExperience;
